import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddServiceLayer from "../../components/service-catalog/AddServiceLayer";

const AddServicePage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Add Service" />
        <AddServiceLayer />
      </MasterLayout>
    </>
  );
};

export default AddServicePage;
